import { render } from "./RdvExtraFieldsForm.vue?vue&type=template&id=617a0e48&scoped=true"
import script from "./RdvExtraFieldsForm.vue?vue&type=script&lang=js"
export * from "./RdvExtraFieldsForm.vue?vue&type=script&lang=js"

import "./RdvExtraFieldsForm.vue?vue&type=style&index=0&id=617a0e48&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-617a0e48"

export default script